<template>
  <div class="hero">
    <div class="hero-image-wrapper">
      <img
        :src="require(`@images/result/heroes/faces/${heroImageId}.png`)"
        class="hero-image"
        height="183"
        width="181"
      >
      <img
        :src="require(`@images/icon/ico_rank${hero.rank}.png`)"
        class="icon-rank"
        height="79"
        width="78"
      >
    </div>
    <div class="description">
      <span class="hero-name" v-html="$t(`${hero.heroId}`, null, 'localeCharacter')" />
      <p class="series-name" :class="{'-small': isSpanish}" v-html="seriesNames" />
      <span class="vote-count" v-html="$t('text011', {votes: count(hero.voteCount)}, 'localeResult')" />
    </div>
  </div>
</template>

<script>
import { localeFigure } from '@constants'
import localeResult from '@locales/result'
import localeCharacter from '@locales/character'
import localeSeries from '@locales/series'
export default {
  name: 'hero',
  $messages: { localeResult, localeCharacter, localeSeries },
  props: {
    hero: {
      type: Object,
      required: true,
    }
  },
  computed: {
    seriesNames(){
      let seriesNames = this.hero.seriesIds.map(s => {
        return this.$t(`game${s.id}.title`, null, 'localeSeries')
      })
      seriesNames = [...new Set(seriesNames)]
      return seriesNames.join('<br>')
    },
    heroImageId() {
      let heroId = this.hero.heroId
      if (this.hero.seriesIds.length > 1) {
        const maxSeries = this.hero.seriesIds.reduce((a,c) => Number(a.voteCount) > Number(c.voteCount) ? a : c)
        heroId = maxSeries.heroId
      }
      return heroId
    },
    isSpanish() {
      if (!this.$route.params.lang) return false
      return /^es-/g.test(this.$route.params.lang)
    }
  },
  methods: {
    count(count) {
      return localeFigure(count, this.$route.params.lang)
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  width: 50%;
  margin-top: -40px;
}
.hero-image-wrapper {
  background-image: url(~@images/result/bg_result-s.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center;
  font-size: $fs-large;
  margin: 0 auto 20px;
  width: 100%;
  height: 318px;
  position: relative;
}
.hero-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.icon-rank {
  position: absolute;
  top: 40px;
  left: 20px;
}
.description {
  background-image: url(~@images/bg_hero-text.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  text-align: center;
  margin: -80px 0 20px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  .hero-name {
    font-size: $fs-base * 1.4;
  }
  .series-name {
    color: #878787;
    font-size: $fs-base * 0.9;
    &.-small {
      font-size: $fs-base * 0.8;
    }
  }
  .vote-count {
    color: #878787;
    font-size: $fs-base * 1.2;
  }
}
</style>
